import moment from 'moment';
import { Divider, Space, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import ItemData from '../Item';
import { getMinutes } from '../../../utils/bookings';
import { IBooking, IBookingEvent } from '../../../interfaces/booking.interface';

interface Props {
    type?: 'SUCCESS' | 'FAILED' | 'RESOLVING'
    booking: IBooking;
    bookingEvent: IBookingEvent;
}

const { Text } = Typography;

const CompletedStatus = ({
    type = 'SUCCESS', booking, bookingEvent,
}: Props) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'DETAIL' });

    const date = moment(bookingEvent?.createdAt).format('DD MMM HH:mm');
    const time = moment(bookingEvent?.createdAt).format('HH:mm');

    // const hasProof = booking?.requiresProofOfDelivery || booking?.proofOfDeliveryType !== 'NONE';
    // const proofType = t(`PROOF.${booking?.proofOfDeliveryType}`);

    return (
        <div className="booking__status--detail">
            <Space direction="vertical" size={4}>
                <Text className="booking__status--detail-title">
                    {t('STORY_LINE.EVENT_DETAILS')}
                </Text>

                <Text className={`booking__status--detail-tag ${type}`}>
                    {t(`STORY_LINE.${type}`)}
                </Text>
            </Space>

            <Text>
                <Trans
                    t={t}
                    i18nKey="STORY_LINE.STATUS.COMPLETED_DESCRIPTION"
                    components={{ b: <b className="booking__status--bold" /> }}
                    values={{
                        customerName: booking?.customerName,
                        time,
                    }}
                />
            </Text>

            <Text className="booking__status--time">
                {date}
            </Text>
            {/* {hasProof && (
                <>
                    <Text>
                        <Trans
                            t={t}
                            i18nKey="PROOF.TEXT"
                            components={{ b: <b className="booking__status--bold" /> }}
                            values={{
                                type: proofType,
                            }}
                        />
                        {booking?.proofValidationCode && (
                            <b>{` ${booking?.proofValidationCode}`}</b>
                        )}
                    </Text>
                    {booking?.proofOfDelivery && (
                        <>
                            <AvatarDeliveryProof
                                proofOfDelivery={booking.proofOfDelivery}
                                expandPhoto={() => openAvatarModal()}
                            />
                            <AvatarModal
                                visible={avatarModal}
                                proofOfDelivery={booking.proofOfDelivery}
                                onCancel={() => closeAvatarModal()}
                            />
                        </>
                    )}
                </>
            )} */}

            <Divider />

            <Text className="booking__status--detail-subtitle">
                {t('STORY_LINE.SUMMARY_ORDER')}
            </Text>

            <div className="booking__status--detail-info">
                <ItemData
                    label={t('LOCATIONS.DISTANCE_COVERED')}
                    value={`${booking?.distanceBreakUp.exactDistance?.toFixed(2) || 0} Km`}
                />
                <ItemData
                    label={t('STORY_LINE.TIME_ELAPSED')}
                    value={`${getMinutes(booking)} min`}
                />
            </div>

        </div>
    );
};

export default CompletedStatus;
